'use strict';

import FacebookModel from 'standard-vote/app/scripts/models/facebook.js';
var _ = require('lodash');

module.exports = FacebookModel.extend({
    defaults: _.extend(_.clone(FacebookModel.prototype.defaults), {
        isEnabled: false
    }),

    /**
     * [ initialize ]
     */
    initialize: function() {
        _.bindAll(this, 'getLoginStatus', 'loginResponse');

        if (this.isEnabled()) {
            this.checkScript();
        }
    },

    isEnabled: function() {
        return this.get('isEnabled');
    },

    loadScript: function() {

        this.set('scriptLoaded', true);

        FB.init({
            appId: this.get('appId'),
            status: true,
            version: 'v10.0'
        });
        const storageKey = this.getStorageKey();

        let loggedout = true;
        try {
            loggedout = localStorage.getItem( storageKey );
        } catch( e ) {
            //Do nothing
        }   
        if( !loggedout ) {
            this.getLoginStatus();
        } else {
            // TCFF-226: We need to set this, because the app waits for the FB response
            // to finish before checking for a persisted email login.
            // Without this, persisted email login never gets set.
            this.set({
                authResponse: null,
                status: 'unknown'
            });
        }
    },

    logout: function( callback ) {
        const storageKey = this.getStorageKey();

        try {
            localStorage.setItem( storageKey, 'true' );
        } catch( e ) {
            //Do nothing
        }   

        FacebookModel.prototype.logout.call( this, callback );
    },

    getStorageKey: function() {
        return 'ts_' + this.get('appId') + '_fblo';
    },

    login: function() {
        const storageKey = this.getStorageKey();

        try {
            localStorage.removeItem( storageKey );
        } catch( e ) {
            //Do nothing
        } 
        FacebookModel.prototype.login.call( this );
    }

});



// WEBPACK FOOTER //
// ./app/scripts/models/facebook.js